import {Component} from '@angular/core';
import {CaseHeaderService} from '../../services/case-header.service';
import {BehaviorSubject, Observable} from 'rxjs';

@Component({
  selector: 'app-case-actions',
  templateUrl: './case-actions.component.html',
  styleUrls: ['./case-actions.component.scss']
})
export class CaseActionsComponent {

  public canSave$: Observable<boolean>;
  public canSubmit$: Observable<boolean>;
  public showSubmit$: Observable<boolean>;
  public isLoading$: Observable<boolean>;

  constructor(private caseHeaderService: CaseHeaderService) {
    this.canSave$ = caseHeaderService.canSave$;
    this.canSubmit$ = caseHeaderService.canSubmit$;
    this.showSubmit$ = caseHeaderService.showSubmit$;
    this.isLoading$ = caseHeaderService.isLoading$;
  }

  public saveClick(): void {
    this.caseHeaderService.handleSave();
  }

  public submitClick(): void {
    this.caseHeaderService.handleSubmit();
  }
}
